import { useState, useEffect } from 'react';
import PromptRes from './components/PromptRes.jsx';
import ChatBox from './components/ChatBox.jsx';
import Sidebar from './components/Sidebar.jsx';
import AdminView from './components/AdminView.jsx';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './App.css';
import Searchbar from './components/Searchbar.jsx';
import { useToken } from './TokenContext.js';
import line from './assets/Line2.gif';
import LightLogo from './assets/enviseer_black.png';
import DarkLogo from './assets/enviseer_white.png';
import ProfilePage from './components/ProfilePage.jsx';
import NotificationPage from './components/NotificationPage.jsx';
import { Route, Routes, useNavigate } from "react-router-dom";
import Doctor from '../src/assets/Doctor.svg';

const App = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [isAdminView, setIsAdminView] = useState(false);
  const [currentSession, setCurrentSession] = useState("");
  const [query, setQuery] = useState("");
  const [queryResponse, setQueryResponse] = useState("");
  const [editMessage, setEditMessage] = useState('');
  const [notifications, setNotifications] = useState([]);
  const [sessionStarted, setSessionStarted] = useState(false);

  useEffect(() => {
    // Check if the user has a theme preference stored in cookies
    const savedTheme = getCookie('theme');
    if (savedTheme === 'dark') {
      setIsDarkMode(true);
      document.body.classList.add('dark-mode');
    }
  }, []);

  

  const navigate = useNavigate();
  const username = decodeURIComponent(getCookie('username'));

  const handleProfileClick = () => {
     navigate("/profile");
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
    //console.log(sidebarOpen);
  };

  const toggleTheme = () => {
    const newTheme = !isDarkMode;
    setIsDarkMode(newTheme);

    // Apply the new theme
    if (newTheme) {
      document.body.classList.add('dark-mode');
      setCookie('theme', 'dark', 365); // Set dark mode in cookie
    } else {
      document.body.classList.remove('dark-mode');
      setCookie('theme', 'light', 365); // Set light mode in cookie
    }
  };

  const toggleAdminView = () => {
    setIsAdminView(!isAdminView);
    // Additional logic for toggling between admin and user view can be added here
    //console.log("Admin View:", isAdminView);
  };

  const updateSession = (query) => {
    setCurrentSession(query);
    setQuery('');
    setQueryResponse('');
    //console.log("currentSession", query);
  };

  const updateQuery = (currentQuery) => {
    setQuery(currentQuery);
    // setQueryResponse("Loading...");
    setQueryResponse(<img src={line} alt="Loading..." width="100%" height="150px" />);
  };

  const updateQueryResponse = (queryResponse) => {
    setQueryResponse(queryResponse);
  };

  const updateEditMessage = (msg) => {
    setEditMessage(msg);
    //console.log("lllllllddddddddddd", msg);
  };

  const updateNotification = (newNotification) => {
    setNotifications((prevNotifications) => [...prevNotifications, newNotification]);
    //console.log("qqqqqqqqqqq", newNotification);
  };

  const updateSessionStarted = (value)=>{
    //console.log("hhhhhhhhhhhhhhhhhhhhhhhhhhhhhh",value);
    if(value==='true'){
    setSessionStarted(true);}
    else{
      setSessionStarted(false);
    }
  }

  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  }

  function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/`;
  }

  // If token is undefined, the user is a guest
  //console.log("33333333333333333333", useToken().isGuestToken);
  const isGuest = useToken().isGuestToken
  const companyName = useToken().companyName;
  //console.log("companyname", companyName);
  return (
    
    <div className="app">
      <Routes>
        <Route
          path="/envibuddy/"
          element={
            <>
              {!isGuest && !isAdminView ? (
                <div style={{ backgroundColor: '#F9F9F9', zIndex: '99999' }}>
                  <Sidebar
                    sidebarOpen={sidebarOpen}
                    toggleSidebar={toggleSidebar}
                    isAdminView={isAdminView}
                    isDarkMode={isDarkMode}
                    currentSession={currentSession}
                    updateSession={updateSession}
                    queryResponse={queryResponse}
                    username={username}
                    query={query}
                  />
                </div>
              ) : null}
              <div
                className={isGuest?"bodyGuest":"body"}
                style={{
                  marginLeft:
                    sidebarOpen && window.innerWidth <= 480 ? '-250px' : '0px',
                  filter:
                    sidebarOpen && window.innerWidth <= 480 ? 'blur(2px)' : '',
                  pointerEvents:
                    sidebarOpen && window.innerWidth <= 480 ? 'none' : '',
                }}
              >
                {!isGuest ? (
                  <div className="bodyHeader">
                    <div className="chatName">
                      <img
                        className="chatLogo"
                        src={isDarkMode ? DarkLogo : LightLogo}
                        alt="logo"
                      />
                      <p>EnviBuddy</p>
                    </div>
                    <div className="searchbar">
                      <Searchbar
                        isDarkMode={isDarkMode}
                        isAdminView={isAdminView}
                        toggleAdminView={toggleAdminView}
                        toggleTheme={toggleTheme}
                        notifications={notifications}
                        handleProfileClick={handleProfileClick}
                      />
                    </div>
                  </div>
                ): 
                <div className={sessionStarted!==true? "bodyHeaderGuest":"bodyHeaderGuestComp"}>
                  <div className={sessionStarted!==true? 'GuestIconContainer':'GuestIconContainerComp'}>
                    <img className="GuestIcon" src={Doctor} alt="logo"/></div>
                   <div className={sessionStarted===true? "heading":""}>
                     <div className="chatName">
                      <p style={{color:'white'}}>EnviBuddy</p>
                    </div>
                    <div style={{color:"#e4e1e6", fontWeight:"400", opacity:"0.6", fontSize:"14px", marginLeft: sessionStarted===true? '20px':'0px'}}>Your Digital Assistant for a Brighter Tomorrow</div></div>
                    </div>
                }



                <div
                  className={isGuest? "containtBoxGuest":"containtBox"}
                  style={{ height: isAdminView ? '100%' : (isGuest? (sessionStarted===false ? '66%' : '84%'): '88%') }}
                >
                  {isAdminView ? (
                    <div
                      style={{
                        display: 'flex',
                        width: '100%',
                        height: '100%',
                        justifyContent: 'center',
                      }}
                    >
                      <AdminView username={username} updateNotification={updateNotification} />
                    </div>
                  ) : (
                    <div
                      style={{
                        display: 'flex',
                        width: '100%',
                        justifyContent: 'center',
                        height: '100%',
                        boxSizing: 'border-box',
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          width: '100%',
                          height: '100%',
                          boxSizing: 'border-box',
                          overflow: 'hidden',
                        }}
                      >
                        <main className="main-content">
                          <PromptRes
                            currentSession={currentSession}
                            updateSession={updateSession}
                            query={query}
                            queryResponse={queryResponse}
                            updateQuery={updateQuery}
                            updateQueryResponse={updateQueryResponse}
                            updateEditMessage={updateEditMessage}
                            username={username}
                            updateSessionStarted = {updateSessionStarted}
                          />
                        </main>
                        <div className="chat-box-container">
                          <ChatBox
                            currentSession={currentSession}
                            updateSession={updateSession}
                            updateQuery={updateQuery}
                            updateQueryResponse={updateQueryResponse}
                            editMessage={editMessage}
                            username={username}
                            updateEditMessage={updateEditMessage}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </>
          }
        />
        <Route
          path="/envibuddy/enviState/"
          element={
            <>
              <div
                className="bodyGuest"
                style={{
                  marginLeft:
                    sidebarOpen && window.innerWidth <= 480 ? '-250px' : '0px',
                  filter:
                    sidebarOpen && window.innerWidth <= 480 ? 'blur(2px)' : '',
                  pointerEvents:
                    sidebarOpen && window.innerWidth <= 480 ? 'none' : '',
                }}
              >
                
                <div className={sessionStarted!==true? "bodyHeaderGuest":"bodyHeaderGuestComp"}>
                  <div className={sessionStarted!==true? 'GuestIconContainer':'GuestIconContainerComp'}>
                    <img className={sessionStarted!==true? "GuestIcon":"GuestIconComp"} src={LightLogo} alt="logo"/></div>
                   <div className={sessionStarted===true? "heading":""}>
                     <div className="chatName">
                      <p style={{color:'white'}}>EnviBuddy</p>
                    </div>
                    <div style={{color:"#e4e1e6", fontWeight:"400", opacity:"0.6", fontSize:"14px", marginLeft: sessionStarted===true? '20px':'0px'}}>Your Digital Assistant for a Brighter Tomorrow</div></div>
                    </div>
                



                <div
                  className="containtBoxGuest"
                  style={{ height: isAdminView ? '100%' : (isGuest? (sessionStarted===false ? '66%' : '84%'): '88%') }}
                >
                  
                    <div
                      style={{
                        display: 'flex',
                        width: '100%',
                        justifyContent: 'center',
                        height: '100%',
                        boxSizing: 'border-box',
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          width: '100%',
                          height: '100%',
                          boxSizing: 'border-box',
                          overflow: 'hidden',
                        }}
                      >
                        <main className="main-content">
                          <PromptRes
                            currentSession={currentSession}
                            updateSession={updateSession}
                            query={query}
                            queryResponse={queryResponse}
                            updateQuery={updateQuery}
                            updateQueryResponse={updateQueryResponse}
                            updateEditMessage={updateEditMessage}
                            username={username}
                            updateSessionStarted = {updateSessionStarted}
                          />
                        </main>
                        <div className="chat-box-container">
                          <ChatBox
                            currentSession={currentSession}
                            updateSession={updateSession}
                            updateQuery={updateQuery}
                            updateQueryResponse={updateQueryResponse}
                            editMessage={editMessage}
                            username={username}
                            updateEditMessage={updateEditMessage}
                          />
                        </div>
                      </div>
                    </div>
                  
                </div>
              </div>
            </>
          }
        />
        <Route
          path="/envibuddy/enviseer/"
          element={
            <>
              <div
                className="bodyGuest"
                style={{
                  marginLeft:
                    sidebarOpen && window.innerWidth <= 480 ? '-250px' : '0px',
                  filter:
                    sidebarOpen && window.innerWidth <= 480 ? 'blur(2px)' : '',
                  pointerEvents:
                    sidebarOpen && window.innerWidth <= 480 ? 'none' : '',
                }}
              >
                
                <div className={sessionStarted!==true? "bodyHeaderGuest":"bodyHeaderGuestComp"}>
                  <div className={sessionStarted!==true? 'GuestIconContainer':'GuestIconContainerComp'}>
                    <img className={sessionStarted!==true? "GuestIcon":"GuestIconComp"} src={LightLogo} alt="logo"/></div>
                   <div className={sessionStarted===true? "heading":""}>
                     <div className="chatName">
                      <p style={{color:'white'}}>EnviBuddy</p>
                    </div>
                    <div style={{color:"#e4e1e6", fontWeight:"400", opacity:"0.6", fontSize:"14px", marginLeft: sessionStarted===true? '20px':'0px'}}>Your Digital Assistant for a Brighter Tomorrow</div></div>
                    </div>
                



                <div
                  className="containtBoxGuest"
                  style={{ height: isAdminView ? '100%' : (isGuest? (sessionStarted===false ? '66%' : '87%'): '88%') }}
                >
                  
                    <div
                      style={{
                        display: 'flex',
                        width: '100%',
                        justifyContent: 'center',
                        height: '100%',
                        boxSizing: 'border-box',
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          width: '100%',
                          height: '100%',
                          boxSizing: 'border-box',
                          overflow: 'hidden',
                        }}
                      >
                        <main className="main-content">
                          <PromptRes
                            currentSession={currentSession}
                            updateSession={updateSession}
                            query={query}
                            queryResponse={queryResponse}
                            updateQuery={updateQuery}
                            updateQueryResponse={updateQueryResponse}
                            updateEditMessage={updateEditMessage}
                            username={username}
                            updateSessionStarted = {updateSessionStarted}
                          />
                        </main>
                        <div className="chat-box-container">
                          <ChatBox
                            currentSession={currentSession}
                            updateSession={updateSession}
                            updateQuery={updateQuery}
                            updateQueryResponse={updateQueryResponse}
                            editMessage={editMessage}
                            username={username}
                            updateEditMessage={updateEditMessage}
                          />
                        </div>
                      </div>
                    </div>
                  
                </div>
              </div>
            </>
          }
        />
        <Route path="/profile" element={<ProfilePage isDarkMode={isDarkMode} isAdminView={isAdminView} toggleAdminView={toggleAdminView} toggleTheme={toggleTheme} />} />
        <Route path="/notifications" element={<NotificationPage notification={notifications} />} />
      </Routes>
    </div>
  );
};

export default App;
